<template>
  <div class="mt-4 ml-3">
    <h5 class="text-warning text-uppercase font-poppins">Applicable law:</h5>
    <div v-for="(ref, index) in applicableLawsSorted" :key="index" class="message__references mt-2">
      <a v-if="ref.url" :href="ref.url" target="_blank">
        <p class="mb-0 mr-2 float-right">
          <small>
            <u class="text-warning">
              {{ "View More" | __t("button__view-more") }}
            </u>
          </small>

          <img src="@/assets/icons/external-link.svg" width="15" height="15" class="ml-2" />
        </p>

        <p class="mb-0 font-weight-bold">
          <span v-if="ref.name" class="message__references-name text-dark">{{ ref.name }}</span>
          <span v-else class="message__references-id">{{ ref.id }}</span>
        </p>
      </a>

      <span v-else>
        <p class="mb-0 font-weight-bold">
          <span v-if="ref.name" class="message__references-name text-dark">{{ ref.name }}</span>
          <span v-else class="message__references-id">{{ ref.id }}</span>
        </p>
      </span>

      <div v-if="ref.excerpt">
        <div class="float-left mr-3">
          <img src="@/assets/icons/quote.svg" width="15" height="15" />
        </div>

        <div>
          <small>
            {{ ref.excerpt }}
          </small>
        </div>
      </div>
    </div>

    <h5 class="mt-3 text-warning text-uppercase font-poppins">References:</h5>
    <div v-for="(ref, index) in referencesSorted" :key="index" class="message__references mt-2">
      <a v-if="ref.url" :href="ref.url" target="_blank">
        <p class="mb-0 mr-2 float-right">
          <small>
            <u class="text-warning">
              {{ "View More" | __t("button__view-more") }}
            </u>
          </small>

          <img src="@/assets/icons/external-link.svg" width="15" height="15" class="ml-2" />
        </p>

        <p class="mb-0">
          <span v-if="ref.name" class="message__references-name text-dark">{{ ref.name }}</span>
          <span v-else class="message__references-id">{{ ref.id }}</span>
        </p>
      </a>

      <span v-else>
        <p class="mb-0">
          <span v-if="ref.name" class="message__references-name text-dark">{{ ref.name }}</span>
          <span v-else class="message__references-id">{{ ref.id }}</span>
        </p>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "References",
  props: {
    references: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    applicableLawsSorted() {
      return this.references.filter(({ isApplicableLaw }) => isApplicableLaw);
    },
    referencesSorted() {
      return this.references.filter(({ isApplicableLaw }) => !isApplicableLaw);
    },
  },
};
</script>
